import { getIntConfigs, getUniqueCard, getAdvertisementTypeList, getBneFormFields } from '../api/offer-diffusion';
import Vue from 'vue';

const initialState = {
  checkOfferModal: false,
  showMultipostingModal: false,
  intConfigs: [],
  intConfigData: [],
  showForm: false,
  multiposting: {
    title: null,
    vacancies: 1,
    description: '',
    country: null,
    province: null,
    city: null,
    educationLevel: null,
    academicSituation: null,
    experience: null,
    experienceYears: '1 año',
    vigency: null,
    position: null,
    salaryMin: null,
    salaryMax: null,
    email: null,
    confidential: false,
    confidentialName: 'Importante empresa',
    requirements: '',
    inclusive: false,
    cvMail: false,
    area: null,
    subarea: null,
    modality: null,
    type: null,
    hierarchy: null,
    benefits: '',
    address: null,
    salaryType: null,
    showSalary: false,
    bneOcupacion: null,
    bneTurnos: { nocturno: false, soloManana: false, finDeSemana: false, soloTarde: false, especiales: false },
    bneFechaInicio: null,
    bneFechaIncorporacion: null,
    bneInvitaciones: 1,
    bneLod: false,
    bnePractica: false,
    bneRelacionContractual: null,
    bneRangoSalarial: null,
    bneVigencia: null,
  },
  exists: false,
  intCompanies: { laborum: null, chiletrabajos: null, trabajando: null, bne: null, kj: null },
  hasKj: false,
  plans: [],
  bneCatalogs: null,
};

export const mutations = {
  setCheckOfferModal(state) {
    state.checkOfferModal = !state.checkOfferModal;
  },
  setShowMultipostingModal(state, payload) {
    if (typeof payload === 'boolean') {
      state.showMultipostingModal = payload;
      return;
    }

    state.showMultipostingModal = !state.showMultipostingModal;
  },
  setIntConfigs(state, payload) {
    state.intConfigs = payload;
  },
  setIntConfigsData(state, payload) {
    state.intConfigData = payload
  },
  setShowForm(state) {
    state.showForm = !state.showForm;
  },
  setMultiposting(state, payload) {
    Vue.set(state.multiposting, payload.key, payload.value);
  },
  setFicha(state, payload) {
    state.multiposting = {
      salaryMin: null,
      salaryMax: payload.salaryMax ?? payload.salary ?? null,
      ...payload,
      salary: undefined
    };
  },
  setExists(state, payload) {
    state.exists = payload;
  },
  setIntCompanies(state, payload) {
    state.intCompanies[payload.key] = payload.value;
  },
  setHasKj(state, payload) {
    state.hasKj = payload;
  },
  setPlans(state, payload) {
    state.plans = payload;
  },
  setBneCatalogs(state, payload) {
    state.bneCatalogs = payload;
  },
};

export const actions = {
  async getIntConfigs({ commit }) {
    const { data } = await getIntConfigs();
    const integrationCompanies = data.integrationCompanies || [];
    const int_configs = integrationCompanies.map(i => i.intConfigId);
    commit('setIntConfigs', int_configs);
    commit('setIntConfigsData', integrationCompanies.map(i => ({ id: i.intConfigId, status: i.state })))

    return integrationCompanies
  },

  async getUniqueCard({ commit }, payload) {
    const res = await getUniqueCard(payload);
    if (res) {
      commit('setFicha', res.data.rawData);
      commit('setExists', true);
    }
  },

  async getAdvertisementTypeList({ commit }) {
    const { data } = await getAdvertisementTypeList();
    if(data){
      const plans = data.map(plan => ({ ...plan, label: `${plan.name} (Saldo: ${plan.quantityAvailable})` }));
      commit('setPlans', plans);
    }
  },

  async loadBneCatalogs({ commit, state }) {
    if (state.bneCatalogs) return;
    try {
      const catalogs = await getBneFormFields();
      if (catalogs) commit('setBneCatalogs', catalogs);
    } catch (error) {
      console.error('[loadBneCatalogs] Failed to fetch BNE catalogs:', error);
    }
  },
};

export const getters = {
  getCheckOfferModal(state) {
    return state.checkOfferModal;
  },
  getShowMultipostingModal(state) {
    return state.showMultipostingModal;
  },
  getIntConfigs(state) {
    return state.intConfigs;
  },
  getShowForm(state) {
    return state.showForm;
  },
  multiposting(state) {
    return state.multiposting;
  },
  exists(state) {
    return state.exists;
  },
  getIntCompanies(state) {
    return state.intCompanies;
  },
  getIntCompaniesData(state) {
    return state.intConfigData
  },
  getHasKj(state) {
    return state.hasKj;
  },
  bneCatalogs(state) {
    return state.bneCatalogs;
  },
};
export default {
  state: { ...initialState },
  mutations,
  actions,
  getters,
};
